import React, { useEffect, useState, useContext } from 'react';
import {
  formatDataForSelectDropdown,
  AppContext,
  EventEmitter,
  useActivityTracker,
  toast,
  sendMessageToContentJS,
  useProduct,
  COMMON_CONSTANTS,
  EventEmitterWithIndex,
  useCheckFeatureGating
} from '@nile/components';
import {
  useCachedQuery,
  GET_ALL_TIMER_ENTRIES,
  GET_AUTO_START_TIMER_INFO,
  AccountClient,
  TicketClient,
  GET_WHITELISTED_SERVICE_ITEMS,
  CREATE_WORKLOG_TIMER_ENTRY,
  UPDATE_WORKLOG_TIMER_ENTRY,
  CREATE_WORKLOG_FROM_TIMERS,
  DELETE_WORKLOG_TIMER,
  GET_AI_WORKLOG_NOTE,
  MLClient,
  AI_WORKLOGNOTE_GENERATE,
  GET_ELIGIBLE_SERVICE_ITEMS
} from '@nile/graphql';
import { SkeletonBodyText } from '@superops/ui-design-system';
import { isEmpty, omit } from 'lodash';
import { useQuery, useMutation, useLazyQuery } from '@apollo/client';
import { injectIntl } from 'react-intl';
import WorklogAutoTimerForm from '@nile/components/src/Containers/NewWorklog/WorklogAutoTimerForm';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { removePropertiesForItProduct } from '@nile/itsm';

function WorklogAutoTimer(props) {
  const {
    intl,
    timer,
    workItem,
    ticket,
    project,
    module,
    editMode,
    allTimerEntries: runningTimerEntries,
    refetch: refetchParent,
    refetchTimerEntry,
    refetchTimerEntries,
    associateWorkItem,
    resetTimerHighlight,
    handleClose,
    handleWorklogCreated,
    handleParentClose,
    highlightTimer,
    showAlltimersList,
    highlightRunningTimer,
    forwardedRef,
    hideCancel,
    hideWorkitem,
    hideDelete,
    disableCloseOnSuccess,
    globaltimerSection,
    aiWorklogNotes,
    disableAutoTimerCloseOnSuccess,
    disableRunningTimerCloseOnSuccess,
    timerNote,
    repositionPopup,
    isAgentChat = false,
    threadData = [],
    autoFocusTimerNotes,
    taskId,
    hideWorklogTask,
    hideTaskWorkItem,
    taskViewOnly,
    hideBlockItemConsumptionInfo
  } = props;
  const appContext = useContext(AppContext);
  const flags = useFlags();
  const currentUser = appContext.user;
  const [loading, setLoading] = useState(false);
  const contractsNew = useCheckFeatureGating('CONTRACT_V3')?.enabled;

  const [timerItem, setTimerItem] = useState(
    timer?.[contractsNew ? 'serviceCatalogItem' : 'serviceItem'] || null
  );
  const [defaultTimerItem, setDefaultTimerItem] = useState(null);
  const [comments, setComments] = useState(timer?.notes || null);
  const [timespent, setTimeSpent] = useState(timer?.timespent || null);
  const [timerState, setTimerState] = useState(timer?.state || null);
  const [running, setRunning] = useState(timer?.running || null);
  const [billable, setBillable] = useState(true);
  const [timerId, setTimerId] = useState(timer?.timerId || null);
  const [segments, setSegments] = useState(timer?.segments || []);
  const [associatedWorkItem, setAssociatedWorkItem] = useState(
    !isEmpty(workItem) ? workItem : null
  );
  const [aiGeneratedNote, setAIgeneratedNote] = useState(false);

  const getWorklogNote = (arr) => {
    let str = '';
    arr.forEach((note, idx) => {
      if (idx > 0) {
        str = str + `\n${note}`;
      } else {
        str = `${note}`;
      }
    });
    return str;
  };

  const skipAIWorklogNotes = !aiWorklogNotes || !timer?.notes || !timerNote;

  const [aiWorklogNoteLoading, setAiWorklogNoteLoading] = useState(false);
  const handleAIError = () => {
    setAiWorklogNoteLoading(false);
  };

  const [getAiWorklog] = useLazyQuery(GET_AI_WORKLOG_NOTE, {
    client: MLClient,
    skip: skipAIWorklogNotes,
    fetchPolicy: 'no-cache',
    variables: {
      text: timer?.notes || timerNote
    },
    onCompleted(res) {
      setAiWorklogNoteLoading(false);
      if (!isEmpty(res?.convertReplyToAIWorklog)) {
        const noteString = getWorklogNote(res?.convertReplyToAIWorklog);
        setComments(noteString);
        setAIgeneratedNote(true);
        setTimeout(() => {
          if (repositionPopup) {
            repositionPopup();
          }
        }, 20);
      }
    }
  });

  const isMSPProduct = useProduct('MSP');

  // const getAllTimerEntries = () => {
  //   TicketClient.query({
  //     query: GET_ALL_TIMER_ENTRIES,
  //     fetchPolicy: 'network-only',
  //     variables: {
  //       worklogTimerInput: workItem
  //         ? {
  //             module: module,
  //             listInfo: {
  //               condition: {
  //                 joinOperator: 'AND',
  //                 operands: getConditionOperands()
  //               }
  //             }
  //           }
  //         : {}
  //     }
  //   }).then((res) => {
  //     setRunningTimerEntries(res.data);
  //     setLoading(false);
  //   });
  // };

  const refetch = () => {
    refetchTimerEntries();
  };

  const resetTimer = () => {
    setTimerItem(null);
    setBillable(true);
    setTimeSpent(null);
    setTimerState(null);
    setRunning(false);
    setComments(null);
    setSegments([]);
    setTimerId(null);
    // EventEmitter.dispatch('resetTimerHighlight');
    if (highlightRunningTimer) resetTimerHighlight();
  };
  const currentProduct = useProduct();
  const [
    createWorklogTimerEntryWithInterceptor,
    {
      loading: createWorklogTimerEntryLoading,
      data: createdWorklogTimerEntry,
      error: createWorklogTimerEntryError
    }
  ] = useMutation(CREATE_WORKLOG_TIMER_ENTRY, {
    onCompleted({ createWorklogTimerEntry: currentCreatedTimer }) {
      if (currentCreatedTimer) {
        setComments(null);
        EventEmitterWithIndex.dispatch('refetchGlobalTimers');
        EventEmitter.dispatch('refetchTimerEntries');
        EventEmitterWithIndex.dispatch('refetchTimerEntries');
        sendMessageToContentJS('refetchGlobalTimers');
        const event = globaltimerSection
          ? 'Started timer from widget'
          : `Started timer from a ${(
              currentCreatedTimer?.workItem?.module || 'TICKET'
            ).toLowerCase()}`;
        useActivityTracker({
          event: event
        });

        if (
          handleClose &&
          !disableCloseOnSuccess &&
          !disableAutoTimerCloseOnSuccess
        )
          handleClose();
        if (taskId) {
          useActivityTracker({
            event: 'Timer initiated at a task - Timer'
          });
        }
      }
    }
  });

  async function createWorklogTimerEntry(variables) {
    try {
      const updatedPayload = removePropertiesForItProduct(
        variables,
        'createWorklogTimerEntry',
        currentProduct
      );
      return await createWorklogTimerEntryWithInterceptor(updatedPayload);
    } catch (ex) {
      return ex;
    }
  }
  const [
    updateWorklogTimerEntryWithInterceptor,
    {
      loading: updateWorklogTimerEntryLoading,
      data: updatedWorklogTimerEntry,
      error: updateWorklogTimerEntryError
    }
  ] = useMutation(UPDATE_WORKLOG_TIMER_ENTRY, {
    onCompleted({ updateWorklogTimerEntry: currentCreatedTimer }) {
      if (currentCreatedTimer) {
        // toast('success', 'timer.entry.update.success.toast');
        const currentTimer = currentCreatedTimer;
        const currentTimerItem =
          currentTimer[contractsNew ? 'serviceCatalogItem' : 'serviceItem'];
        const currentBillable = currentTimer.billable;
        const currentTimeSpent = currentTimer.timespent;
        const currentTimerState = currentTimer.state;
        const currentTimerRunning = currentTimer.running;
        const currentNotes = currentTimer.notes;
        const currentWorkItem = currentTimer.workItem;
        setTimerItem(currentTimerItem);
        setBillable(currentBillable);
        setTimeSpent(currentTimeSpent);
        setTimerState(currentTimerState);
        setRunning(currentTimerRunning);
        setComments(currentNotes);
        setSegments(currentTimer?.segments || []);
        setTimerId(currentTimer.timerId);
        setAssociatedWorkItem(currentWorkItem);
        EventEmitter.dispatch('refetchTimerEntries');
        EventEmitterWithIndex.dispatch('refetchGlobalTimers');
        EventEmitterWithIndex.dispatch('refetchTimerEntries');
        if (refetchTimerEntry) {
          refetchTimerEntry(currentTimer.timerId);
        }
        sendMessageToContentJS('refetchGlobalTimers');

        // EventEmitter.dispatch('refetchTimerEntry');

        if (highlightRunningTimer) {
          if (!currentTimerRunning) {
            if (running && !editMode) resetTimer();
            resetTimerHighlight();
          } else {
            highlightTimer();
          }
        }
        let allowClose =
          !disableCloseOnSuccess && !disableAutoTimerCloseOnSuccess;

        if (currentTimerRunning && !disableRunningTimerCloseOnSuccess) {
          allowClose = !disableCloseOnSuccess;
        }

        if (handleClose && allowClose) {
          handleClose();
        }

        if (taskId) {
          useActivityTracker({
            event: 'Time logged converted to worklog - Timer'
          });
        }
      }
    }
  });

  async function updateWorklogTimerEntry(variables) {
    try {
      const updatedPayload = removePropertiesForItProduct(
        variables,
        'updateWorklogTimerEntry',
        currentProduct
      );
      return await updateWorklogTimerEntryWithInterceptor(updatedPayload);
    } catch (ex) {
      return ex;
    }
  }

  const [
    createWorklogEntryFromTimer,
    {
      loading: createWorklogEntryFromTimerLoading,
      data: worklogEntry,
      error: createWorklogEntryFromTimerError
    }
  ] = useMutation(CREATE_WORKLOG_FROM_TIMERS, {
    onCompleted({ createWorklogEntriesFromTimers: createdWorklog }) {
      if (createdWorklog) {
        toast('success', 'worklog.create.from.timer.success.toast');
        EventEmitterWithIndex.dispatch('refetchWorklogs');
        EventEmitterWithIndex.dispatch('refetchGlobalTimers');
        sendMessageToContentJS('refetchGlobalTimers');
        useActivityTracker({
          event: 'Ticket - Adding a time entry on tickets'
        });
        EventEmitter.dispatch('refetchTimerEntries');
        EventEmitterWithIndex.dispatch('refetchTimerEntries');

        if (handleClose && !disableCloseOnSuccess) handleClose();
        if (handleWorklogCreated) handleWorklogCreated(createdWorklog?.[0]);
      }
    }
  });

  const createWorklogEntryFromTimerInterceptor = ({
    timer: timerToConvert
  }) => {
    return createWorklogEntryFromTimer({
      variables: {
        input: [
          {
            timerId: timerToConvert.timerId
          }
        ]
      }
    });
  };

  const [
    deleteWorklogTimerEntry,
    {
      loading: deleteWorklogTimerEntryLoading,
      data: deletedEntry,
      error: deleteWorklogTimerEntryError
    }
  ] = useMutation(DELETE_WORKLOG_TIMER, {
    onCompleted(res) {
      if (res?.deleteWorklogTimerEntry) {
        toast('success', 'timer.entry.delete.success.toast');
        setTimerItem(null);
        setBillable(true);
        setTimeSpent(null);
        setTimerState(null);
        setRunning(false);
        setComments(null);
        setSegments([]);
        setTimerId(null);
        // EventEmitter.dispatch('resetTimerHighlight');
        EventEmitter.dispatch('refetchTimerEntries');
        EventEmitterWithIndex.dispatch('refetchTimerEntries');
        if (highlightRunningTimer) resetTimerHighlight();
        EventEmitterWithIndex.dispatch('refetchGlobalTimers');
        sendMessageToContentJS('refetchGlobalTimers');

        if (handleClose && !disableCloseOnSuccess) handleClose();
      }
    }
  });

  const getConditionOperands = () => {
    return workItem?.workId
      ? [
          {
            attribute: 'workItem.workId',
            operator: 'is',
            value: workItem?.workId
          }
        ]
      : null;
  };

  const getClientId = () => {
    return associatedWorkItem?.client?.accountId;
  };

  // const { loading, data: runningTimerEntries, error, refetch } = useQuery(
  //   GET_ALL_TIMER_ENTRIES,
  //   {
  //     fetchPolicy: 'network-only',
  //     variables: {
  //       worklogTimerInput: {
  //         module: module,
  //         listInfo: {
  //           condition: {
  //             joinOperator: 'AND',
  //             operands: getConditionOperands()
  //           }
  //         }
  //       }
  //     },
  //     onCompleted(response) {
  //       console.log(response);
  //     }
  //   }
  // );
  const {
    loading: autoStartConfigLoading,
    data: autoStartConfig,
    error: autoStartConfigError
  } = useQuery(GET_AUTO_START_TIMER_INFO, {
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE
  });
  const refetchWorklogTimers = () => {
    refetch();
  };
  // useEffect(() => {
  //   EventEmitter.subscribe('refetchWorklogTimers', refetchWorklogTimers);
  //   return function cleanup() {
  //     EventEmitter.unsubscribe('refetchWorklogTimers');
  //   };
  // }, []);
  useEffect(() => {
    if (autoStartConfig?.getAutoStartTimerInfo) {
      const defaultConfig = autoStartConfig?.getAutoStartTimerInfo;
      setDefaultTimerItem(
        defaultConfig?.[
          contractsNew ? 'defaultServiceCatalogItem' : 'defaultServiceItem'
        ]
      );
    }
  }, [autoStartConfig]);
  useEffect(() => {
    const defaultConfig = autoStartConfig?.getAutoStartTimerInfo;
    if (
      defaultConfig &&
      !editMode &&
      module === 'TICKET' &&
      workItem?.technician?.email === currentUser?.email &&
      defaultConfig?.autoStartTimer &&
      !workItem.worklogTimerStarted
    ) {
      createWorklogTimerEntry({
        variables: {
          timerEntryInput: {
            billable: true,
            [contractsNew ? 'serviceCatalogItem' : 'serviceItem']: {
              itemId:
                defaultConfig?.[
                  contractsNew
                    ? 'defaultServiceCatalogItem'
                    : 'defaultServiceItem'
                ]?.itemId
            },
            type: 'AUTOMATIC',
            notes: '',
            workItem: {
              workId: workItem.workId,
              module: module
            }
          }
        }
      }).then((res) => {
        refetchWorklogTimers();
        if (refetchParent) {
          refetchParent();
        }
      });
    }
  }, [autoStartConfig, workItem?.technician]);

  const highlightTimerFunc = (timerEntries) => {
    if (highlightRunningTimer && timerEntries) {
      // const currentTimer =
      //   runningTimerEntries?.fetchWorklogTimerEntries?.entries?.[0] || {};

      const runningTimer = timerEntries?.find((worklogTimer) => {
        return worklogTimer?.running;
      });

      if (runningTimer && !isEmpty(runningTimer)) {
        const currentTimerItem =
          runningTimer[contractsNew ? 'serviceCatalogItem' : 'serviceItem'];
        const currentBillable = runningTimer.billable;
        const currentTimeSpent = runningTimer.timespent;
        const currentTimerState = runningTimer.state;
        const currentTimerRunning = runningTimer.running;
        const currentNotes = runningTimer.notes;
        const currentWorkItem = runningTimer.workItem;
        setTimerItem(currentTimerItem);
        setBillable(currentBillable);
        setTimeSpent(currentTimeSpent);
        setTimerState(currentTimerState);
        setRunning(currentTimerRunning);
        setAssociatedWorkItem(currentWorkItem);
        setComments(currentNotes);
        setSegments(runningTimer?.segments || []);
        setTimerId(runningTimer.timerId);
        if (currentTimerRunning && !editMode) {
          // EventEmitter.dispatch('highlightTimer');
          highlightTimer();
        }
      } else {
        if (showAlltimersList) resetTimer();
      }
    }
  };

  const getAIGeneratedNote = () => {
    if (!isEmpty(threadData)) {
      MLClient.query({
        query: AI_WORKLOGNOTE_GENERATE,
        variables: {
          ticketId: threadData?.workItem?.workId,
          conversationThreadId: threadData?.threadId
        }
      }).then((res) => {
        if (res?.data?.convertChatToAIWorklog) {
          setComments(res?.data?.convertChatToAIWorklog?.join(' '));
        }
      });
    }
  };

  useEffect(() => {
    EventEmitter.subscribe('aiError', handleAIError);
    if (!skipAIWorklogNotes) {
      setAiWorklogNoteLoading(true);
      getAiWorklog({
        variables: {
          text: timer?.notes || timerNote
        }
      });
    }
    if (isAgentChat) {
      getAIGeneratedNote();
    }
    if (!editMode) refetchTimerEntries();

    return function cleanup() {
      EventEmitter.unsubscribe('aiError');
    };
  }, []);

  useEffect(() => {
    if (timer?.hasOwnProperty('billable')) {
      setBillable(timer?.billable);
    }
  }, [timer?.billable]);

  useEffect(() => {
    if (timer?.hasOwnProperty('timespent')) {
      setTimeSpent(timer?.timespent);
    }
  }, [timer?.timespent]);

  useEffect(() => {
    highlightTimerFunc(runningTimerEntries);
  }, [runningTimerEntries]);

  const contractId = ticket
    ? ticket?.contractTicketMapping?.find((ticketMap) => ticketMap.inUse)
        ?.contract?.contractId
    : project?.contract?.contractId;

  const {
    loading: itemsForTimeTrackingLoading,
    data: itemsForTimeTracking,
    error: itemsForTimeTrackingError
  } = useQuery(
    contractsNew ? GET_ELIGIBLE_SERVICE_ITEMS : GET_WHITELISTED_SERVICE_ITEMS,
    {
      client: AccountClient,
      skip: !associatedWorkItem?.client?.accountId,
      variables: contractsNew
        ? {
            input: {
              ...(contractId && {
                contract: {
                  contractId
                }
              }),
              listInfo: {
                sort: {
                  attribute: 'name',
                  order: 'ASC'
                },
                condition: {
                  joinOperator: 'AND',
                  operands: [
                    {
                      attribute: 'serviceTypeItem.offeringType',
                      operator: 'is',
                      value: 'HOURS'
                    }
                  ]
                }
              }
            }
          }
        : {
            clientId: getClientId(),
            listInfo: {
              sort: {
                attribute: 'name',
                order: 'ASC'
              },
              condition: {
                joinOperator: 'AND',
                operands: [
                  {
                    attribute: 'useAsWorklogItem',
                    operator: 'is',
                    value: true
                  },
                  { attribute: 'quantityType', operator: 'is', value: 'HOURS' }
                ]
              }
            }
          }
    }
  );

  const handleAssociateWorkItem = (module, workitem) => {
    if (workitem) {
      setAssociatedWorkItem(workitem);
      if (autoStartConfig?.getAutoStartTimerInfo) {
        setDefaultTimerItem(
          autoStartConfig?.getAutoStartTimerInfo?.[
            contractsNew ? 'defaultServiceCatalogItem' : 'defaultServiceItem'
          ]
        );
      }
    }
  };

  if (loading || autoStartConfigLoading || aiWorklogNoteLoading) {
    return (
      <div className="p20 full-width">
        {/* <div className="flex center full-width">
        <SkeletonThumbnail size="small" />
        <div className="ml10 full-width">
          <SkeletonBodyText size="large" lines={1} />
        </div>
      </div>
      <div className="flex center full-width mt10">
        <SkeletonThumbnail size="small" />
        <div className="ml10 full-width">
          <SkeletonBodyText size="large" lines={1} />
        </div>
      </div> */}
        <SkeletonBodyText size="large" lines={3} />
      </div>
    );
  }
  // if (runningTimerEntries?.fetchWorklogTimerEntries?.entries?.length) {
  //   return (
  //     <div className="p20 full-width">
  //       <div>Running timers are there</div>
  //     </div>
  //   );
  // }
  const options = itemsForTimeTracking
    ? formatDataForSelectDropdown(
        itemsForTimeTracking[
          contractsNew
            ? 'getEligibleServiceCatalogItems'
            : 'getWhitelistedServiceItems'
        ]?.items
      )
    : [];
  const selectedItem = timerItem || defaultTimerItem;
  const handlePropChange = (property, value) => {
    switch (property) {
      case 'billable':
        setBillable(value);
        break;
      case 'serviceItem':
        setTimerItem(value);
        break;
      case 'serviceCatalogItem':
        setTimerItem(value);
        break;
      case 'comments':
        setComments(value);
        break;
      case 'running':
        setRunning(value);
        break;
      default:
        break;
    }
  };

  return (
    <WorklogAutoTimerForm
      intl={intl}
      timer={timer}
      editMode={editMode}
      associateWorkItem={associateWorkItem}
      reAssociateWorkItem
      // reAssociateWorkItem={!workItem && associatedWorkItem}
      options={options}
      selectedItem={selectedItem}
      itemsForTimeTrackingLoading={itemsForTimeTrackingLoading}
      currentUser={currentUser}
      workItem={associatedWorkItem}
      ticket={ticket}
      project={project}
      module={module}
      segments={segments}
      timerItem={timerItem}
      defaultTimerItem={defaultTimerItem}
      comments={comments}
      timespent={timespent}
      billable={billable}
      timerState={timerState}
      running={running}
      timerId={timerId}
      handlePropChange={handlePropChange}
      createWorklogTimerEntry={createWorklogTimerEntry}
      updateWorklogTimerEntry={updateWorklogTimerEntry}
      deleteWorklogTimerEntry={deleteWorklogTimerEntry}
      createWorklogTimerEntryLoading={createWorklogTimerEntryLoading}
      updateWorklogTimerEntryLoading={updateWorklogTimerEntryLoading}
      deleteWorklogTimerEntryLoading={deleteWorklogTimerEntryLoading}
      createWorklogEntryFromTimer={createWorklogEntryFromTimerInterceptor}
      createWorklogEntryFromTimerLoading={createWorklogEntryFromTimerLoading}
      associatedWorkItem={associatedWorkItem}
      handleAssociateWorkItem={handleAssociateWorkItem}
      handleClose={handleClose}
      handleParentClose={handleParentClose}
      forwardedRef={forwardedRef}
      hideCancel={hideCancel}
      hideWorkitem={hideWorkitem}
      hideDelete={hideDelete}
      allowEmptyNotes={props?.allowEmptyNotes}
      aiWorklogNotes={aiWorklogNotes}
      aiGeneratedNote={aiGeneratedNote}
      setAIgeneratedNote={setAIgeneratedNote}
      timerNote={timerNote}
      isAgentChat={isAgentChat}
      autoFocusTimerNotes={autoFocusTimerNotes}
      taskId={taskId}
      hideWorklogTask={hideWorklogTask}
      hideTaskWorkItem={hideTaskWorkItem}
      taskViewOnly={taskViewOnly}
      hideBlockItemConsumptionInfo={hideBlockItemConsumptionInfo}
    />
  );
}

export default injectIntl(WorklogAutoTimer);
